'use client';
import Tile from 'components/commercetools-ui/organisms/product-category-slider/tile';
import { getHeadingStyles } from 'components/commercetools-ui/organisms/utils';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { mobile } from 'helpers/utils/screensizes';
import { cleanString } from 'helpers/utils/util';
import { useProjectSettings } from 'frontastic';
import { SubCategoriesDataProps, SubCategoryBannerProps } from '../../types';

const SubCategoriesBanner = ({
  subCategories,
  subCatConfig,
  currentCategory = '',
}: {
  subCategories: SubCategoriesDataProps;
  subCatConfig: SubCategoryBannerProps[];
  currentCategory?: string;
}) => {
  const { items } = subCategories;
  const { projectSettings } = useProjectSettings();
  const { categories = [] } = projectSettings || {};
  const categoryData = categories.find((item) => item.categoryKey === items?.[0]?.parentKey);
  const categoryKeySet = new Set(categoryData?.descendants?.map((item) => item.categoryKey));
  const [isDesktopSize] = useMediaQuery(mobile);

  const intersection = items?.filter((item) => (item?.categoryKey ? categoryKeySet.has(item?.categoryKey) : false));

  const data = {
    ...subCatConfig?.[0]?.containerConfig?.[0],
    slides: intersection?.map((cat) => {
      const subCategoryData = categoryData?.descendants?.find((entity) => entity.categoryKey === cat.categoryKey);
      return {
        imageSrc: subCategoryData?.categoryImage,
        image: {
          src: subCategoryData?.categoryImage,
          alt: subCategoryData?.categoryImageAlt,
        },
        imageAlt: subCategoryData?.categoryImageAlt ?? cat?.name,
        title: cat?.name ?? '',
        headLine: [
          {
            ...subCatConfig?.[0]?.cardConfig?.[0],
          },
        ],
        target: subCategoryData?.categoryURL ?? {
          type: 'link',
          link: '#',
        },
      };
    }),
  };

  return (
    <div className="container py-0 sm:px-0">
      <h3
        className="mb-25 text-center md:mb-26"
        data-ffid={`lbl-category-heading${currentCategory ? '-' + cleanString(currentCategory) : ''}`}
        style={getHeadingStyles(
          [
            {
              desktopHeadingFontSize: subCatConfig?.[0]?.containerConfig?.[0]?.primaryHeading?.[0]?.fontSizeDesktop,
              mobileHeadingFontSize: subCatConfig?.[0]?.containerConfig?.[0]?.primaryHeading?.[0]?.fontSizeMobile,
              desktopHeadingFontColor: subCatConfig?.[0]?.containerConfig?.[0]?.primaryHeading?.[0]?.textColor,
              mobileHeadingFontColor: subCatConfig?.[0]?.containerConfig?.[0]?.primaryHeading?.[0]?.textColor,
              desktopHeadingFontWeight:
                subCatConfig?.[0]?.containerConfig?.[0]?.primaryHeading?.[0]?.primaryHeadingTextStyle,
              mobileHeadingFontWeight:
                subCatConfig?.[0]?.containerConfig?.[0]?.primaryHeading?.[0]?.primaryHeadingTextStyle,
            },
          ],
          isDesktopSize,
        )}
      >
        {currentCategory || ''}
      </h3>
      {Boolean(data?.slides?.length) && (
        <div
          data-ffid={`ctr-category-section-${currentCategory ? '-' + cleanString(currentCategory) : ''}`}
          className="grid w-full grid-cols-2 gap-12 md:grid-cols-4 md:gap-24 md:gap-y-40"
        >
          {data?.slides?.map((tile, index: number) => (
            <Tile
              key={'tile' + index}
              keyProp={index}
              tile={tile}
              backgroundColor={{ lightColor: data?.cardColor, darkColor: data?.cardColor }}
              backgroundImage={data?.backImageSrc}
              isCarousel={false}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SubCategoriesBanner;
